import React, { FunctionComponent, useState, useEffect } from "react"
import { IconButton, CircularProgress } from "@material-ui/core"
import GetAppIcon from "@material-ui/icons/GetApp"

interface DownloadButtonProps {
    id: string
    fileName: string | undefined
    blob: Blob | undefined
    visible: boolean
}

export const DownloadButton: FunctionComponent<DownloadButtonProps> = (
    props: DownloadButtonProps
) => {
    const [url, setUrl] = useState<undefined | string>(undefined)
    const { id, fileName, blob, visible } = props
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setLoading(true)
        if (blob instanceof Blob) {
            setUrl(window.URL.createObjectURL(blob))
            setLoading(false)
        }
    }, [blob])
    return (
        <>
            {visible &&
                (loading ? (
                    <CircularProgress data-testid="downloadLoadingSpinner" />
                ) : (
                    <a id={id} href={url} download={fileName} data-testid="downloadButton">
                        <IconButton>
                            <GetAppIcon />
                        </IconButton>
                    </a>
                ))}
        </>
    )
}
